import {useDispatch} from 'react-redux';
import {setStage} from '../../../../../reducers/wallet/actions/cashapp_deposit';
import BlueButton from '../../../../components/blue-button';
import ModalsLib from '../../../../../lib/modals';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination} from 'swiper/modules';

export default () => {
    const dispatch = useDispatch();

    return (
        <>
            <div className="modal-header">
                <div className="modal-header-left">
                    {/* <div className="title">CashApp</div>
                    <div className="descriptions">Please read the information provided below before making a deposit</div> */}
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="cashapp-guide">
                    <div className="main-title">How to make deposits with CashApp?</div>

                    <Swiper
                        modules={[Pagination]}
                        pagination={{
                            el: '.dots',
                            clickable: true,
                            renderBullet: (index, className) => {
                                return `<div class="dot ${className}" data-index="${index}"></div>`
                            }
                        }}
                        slidesPerGroup={1}
                        slidesPerView={1}
                    >
                        <SwiperSlide>
                            <div className="guide-tab">
                                <img src={`${window.location.origin}/source/system/cashapp-guide/btcgift1.png`} />

                                <div className="guide-tab-text">
                                    Find Bitcoin section on home screen and tap on it
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="guide-tab">
                                <img src={`${window.location.origin}/source/system/cashapp-guide/btcgift2.png`} />

                                <div className="guide-tab-text">
                                    Scroll down to "Ways to use Bitcoin" and select Bitcoin Gifting
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="guide-tab">
                                <img src={`${window.location.origin}/source/system/cashapp-guide/btcgift3.png`} />

                                <div className="guide-tab-text">
                                    Enter the amount and the recipient's tag
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>

                    <div className="dots">

                    </div>
                </div>
                <div className="modal-message info">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#0C76DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 12.5L11.5 14L14.75 11" stroke="#0C76DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <span>
                        You pay with the Cash balance when sending a Bitcoin Gift. <b>If you send a Cash payment, your payment will be canceled.</b>
                    </span>
                </div>

                <div className="modal-message success">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#0CDA50" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 12.5L11.5 14L14.75 11" stroke="#0CDA50" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>You can send Bitcoin Gifts even from an unverified account.</span>
                </div>
            </div>
            <div className="modal-footer">
                <BlueButton onClick={e => {
                    dispatch(setStage('create'))
                }}>
                    Continue
                </BlueButton>
                <div className="button back" onClick={e => dispatch(setStage('choose'))}>
                    Back
                </div>
            </div>
        </>
    )
}